export async function checkEmail(email) {
    const response = await fetch(`${process.env.REACT_APP_API}/api/candidate/validation/${email}`, {
        method: "GET"
    });

    const data = await response.json();
    if (!data.success) {
        throw new Error("This user has already sent a video.");
    }

    return data; // Return the response data
}
